export const isKaspiUrl = (url: string): boolean => {
  return url.toLowerCase().startsWith('https://kaspi.kz/pay');
};
